import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=2d7a7f92&"
import script from "./TeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEdit.vue?vue&type=style&index=0&id=2d7a7f92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports